module.exports = __webpack_public_path__ + "static/media/wedding_map.c7377d6f.jpg";